export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
              保持联系
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mt-3">
              有想看的浪漫电影推荐？欢迎与我们分享你的二人世界电影心愿单
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-10">
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@夫妻影院.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-3">
                  <i className="ri-message-2-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线留言</h3>
                <p className="text-sm text-foreground-500">24小时内回复</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mx-auto mb-3">
                  <i className="ri-film-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">影片投稿</h3>
                <p className="text-sm text-foreground-500">推荐你心中的佳作</p>
              </div>
            </div>

            <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">你的称呼</label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300/60 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                    placeholder="请输入你的名字"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300/60 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                    placeholder="请输入邮箱地址"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300/60 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                  placeholder="请描述你想看的电影类型或具体片名..."
                ></textarea>
              </div>
              <button
                type="submit"
                className="bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-full text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                发送留言
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}